goog.provide("shadow.js.shim.module$src$svg$controls$ellipsis_vertical_svg$default");
shadow.js.shim.module$src$svg$controls$ellipsis_vertical_svg$default = shadow.js.shim.module$src$svg$controls$ellipsis_vertical_svg.default;
